import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b5129cbe")

_pushScopeId("data-v-b5129cbe")
const _hoisted_1 = {
  key: 0,
  class: "preview-handler-panel"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "close-button-icon el-icon el-icon-close" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_pdf_preview = _resolveComponent("pdf-preview")

  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withId(() => [
      (_ctx.showPanel)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            (_ctx.showPanel)
              ? (_openBlock(), _createBlock(_component_pdf_preview, {
                  key: 0,
                  file: _ctx.file,
                  onError: _cache[2] || (_cache[2] = ($event: any) => (_ctx.previewError()))
                }, {
                  closeButton: _withId(() => [
                    _createVNode("button", {
                      "aria-label": "close drawer",
                      type: "button",
                      class: "panel-close-button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDrawer()))
                    }, [
                      _hoisted_2
                    ])
                  ]),
                  _: 1
                }, 8, ["file"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})